export default __webpack_public_path__ + "static/media/Flag of Cayman Islands.2c2780dc.gif";